import AthleteMatchStats from './AthleteMatchStats';

export default AthleteMatchStats;
